import Component from './applicant_filter.vue'
export default Component
